import React from 'react'
import clsx from 'clsx'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import Slick from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import * as styles from '../styles/components/SuccessCases.module.scss'

import { SectionTitle } from './SectionTitle'
import { defaultSuccessCases } from '../utils/SuccessCasesItems'

interface SuccessCasesProps {
  listCases?: caseItem[]
  isNumericCases?: boolean
}

interface caseItem {
  title: string
  text: string
  quantity?: number
}

export const SuccessCases: React.FC<SuccessCasesProps> = ({
  listCases,
  isNumericCases,
}) => {
  return (
    <section id="cases-sucesso" className={clsx([`my-5`, styles.cases])}>
      <div className="container">
        <SectionTitle
          title="Cases de Sucesso"
          description="Veja alguns de nossos cases de sucesso. Entre em contato e saiba mais sobre nossas melhorias que transformaram as organizações."
          whiteFavicon
          className="casesTitle"
        />
        <div className={styles.mainCases}>
          <Slick
            className={styles.slick}
            adaptiveHeight={true}
            infinite={false}
            autoplay={false}
            slidesToShow={3}
            slidesToScroll={1}
            dots={false}
            draggable={false}
            speed={300}
            dotsClass={clsx([`slick-dots`, styles.customDots])}
            nextArrow={<FontAwesomeIcon icon={faChevronRight} />}
            prevArrow={<FontAwesomeIcon icon={faChevronLeft} />}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  dots: true,
                  arrows: false,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows: false,
                },
              },
            ]}
          >
            {listCases &&
              listCases.map((item, key) => (
                <div className={styles.caseBox} key={key}>
                  <div
                    className={clsx(styles.caseItem, {
                      [styles.onlyText]: isNumericCases,
                    })}
                  >
                    <div className={styles.title}>
                      <h2>{item.title}</h2>
                      <p>{item.text}</p>
                    </div>
                    {!isNumericCases && (
                      <div className={styles.counter}>
                        {item.quantity}
                        <span>Melhorias</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            {!listCases &&
              defaultSuccessCases.map((item, key) => (
                <div className={styles.caseBox} key={key}>
                  <div className={styles.caseItem}>
                    <div className={styles.title}>
                      <h2>{item.title}</h2>
                      <p>{item.text}</p>
                    </div>
                    <div className={styles.counter}>
                      {item.quantity}
                      <span>Melhorias</span>
                    </div>
                  </div>
                </div>
              ))}
          </Slick>
        </div>
      </div>
    </section>
  )
}
